import React, { useCallback, useEffect, useState } from "react";
import DataTable from "../../components/AdminTable/DataTable";
import { Link } from "react-router-dom";
import Select from "react-select";
import axios from "axios";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";

const defaultLang = localStorage.getItem("rms-lang") || "text_en";

export default function CardTable2({
  heading,
  columns,
  data,
  buttonDataa,
  selectButton,
  setStartDate,
  setEndDate,
  downloads,
  handleOutletSelect,
  dateTime,
  footerConfig,
  showFooter,
}) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [outlets, setOutlets] = useState([]);

  const fetchOutlets = useCallback(() => {
    axios
      .get(`${apiKey}/api/rms/admin/get-outlets`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        const mappedOutlets = res.data.map((outlet) => ({
          value: outlet.id,
          label: outlet.name,
        }));
        setOutlets(mappedOutlets);
      })
      .catch((err) => {
        // setError(err.response?.data?.message);
      })
      .finally(() => {
        // setPageLoading(false);
      });
  }, [user?.token]);

  useEffect(() => {
    if (user?.user.role === "super-admin") {
      fetchOutlets();
    }
  }, [fetchOutlets, user?.user.role]);
  return (
    <div className="my-16">
      <div className="text-d-bg-text text-3xl text-center pt-4 mb-4">
        {heading}
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <div className="flex flex-wrap  gap-5 ms-4 my-2 items-center justify-center">
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb">{languageHelper(defaultLang, "Start Date")}</span>
            <div className="mb-2 pt-0">
              <input
                type={dateTime ? "datetime-local" : "date"}
                onChange={(e) => setStartDate(e.target.value)}
                className="px-2 py-2 text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
              />
            </div>
          </label>
        </div>
        <div>
          <label htmlFor="" className="w-full lg:w-1/3">
            <span className="text-d-bg-text text-sm mb ">{languageHelper(defaultLang, "End Date")}</span>
            <div className="mb-2 pt-0">
              <input
                type={dateTime ? "datetime-local" : "date"}
                onChange={(e) => setEndDate(e.target.value)}
                className="px-2 py-2  text-gray-500 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                required
              />
            </div>
          </label>
        </div>

        {selectButton &&
          selectButton.map((data, index) => (
            <div key={index} className="max-w-sm mt-4 ">
              <form action="" className="flex items-center">
                <Select
                  placeholder={data.placeholder}
                  options={data.options}
                  onChange={data.onChange}
                  className="w-full"
                />
              </form>
            </div>
          ))}
        {user?.user.role === "super-admin" && (
          <div className="max-w-sm mt-4 ">
            <form action="" className="flex items-center">
              <Select
                placeholder={"Outlets"}
                options={outlets}
                onChange={handleOutletSelect}
                className="w-full"
              />
            </form>
          </div>
        )}

        {buttonDataa &&
          buttonDataa.map((data, index) => (
            <Link
              className="bg-d-cat-btn text-white text-sm px-3 text-center py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1  ease-linear transition-all duration-150 mt-3 w-fit"
              type="button"
              to={data.path}
              key={index}
            >
              {data.buttonText}
            </Link>
          ))}
      </div>
      <div className="bg-white p-4 rounded-md shadow">
        <DataTable
          columns={columns}
          data={data}
          downloads={downloads}
          footerConfig={footerConfig}
          showFooter={showFooter}
        />
      </div>
    </div>
  );
}
